module.exports = __webpack_public_path__ + "static/media/Montserrat-BoldItalic.45014625.ttf";